import { Trans } from '@lingui/react'
import { arrayOf, shape, string } from 'prop-types'

import SliderHorizontal from 'views/components/organisms/SliderHorizontal'
import HorizontalSliderItem from 'views/components/organisms/SliderHorizontal/ProductSliderItem'
import {
  DEFAULT_NUMBER_OF_VISIBLE_ITEM,
  VISIBLE_COUNT_MOBILE_DEFAULT,
} from 'views/consts'

import './LastActivity.scss'

const Topics = ({ topics }) => {
  return (
    <>
      <h3>
        <Trans id="metaTag.ratgeber.title" />
      </h3>
      <ul className="a-list-reset">
        {topics.map(item => (
          <li key={`topic-${item.id}`}>
            <a href={item.canonicalUrl}>{item.name}</a>
          </li>
        ))}
      </ul>
    </>
  )
}
Topics.propTypes = {
  topics: arrayOf(shape({ id: string, canonicalUrl: string, name: string }))
    .isRequired,
}

const LastActivity = ({ products, topics }) => {
  const hasProducts = Boolean(products?.length)
  const hasTopics = Boolean(topics?.length)

  if (!hasProducts && !hasTopics) {
    return null
  }

  return (
    <div className="o-LastActivity u-margin-x-large--bottom">
      <h2 className="o-LastActivity__title">
        <Trans id="productSliders.lastActivities.headline" />
      </h2>
      <div className="l-flex l-flex--stretch-children l-flex--wrap">
        {hasProducts && (
          <div className="l-col--12-of-12 l-col--6-of-12@medium u-padding-large--right@medium u-margin--bottom@small-tiny o-LastActivity__slider">
            <h3 className="o-LastActivity__subtitle">
              <Trans id="general.label.viewedProducts" />
            </h3>
            <SliderHorizontal
              items={products.map((product, idx) => (
                <HorizontalSliderItem
                  key={product.id}
                  product={product}
                  thumbnail
                  index={idx}
                />
              ))}
              visibleItemCount={DEFAULT_NUMBER_OF_VISIBLE_ITEM}
              visibleItemCountTiny={VISIBLE_COUNT_MOBILE_DEFAULT}
              adaptableArrows
            />
          </div>
        )}
        {hasTopics && (
          <div className="l-col--12-of-12 l-col--6-of-12@medium o-LastActivity__categories">
            {hasTopics && <Topics topics={topics} />}
          </div>
        )}
      </div>
    </div>
  )
}

LastActivity.propTypes = {
  products: arrayOf(shape({})),
  topics: arrayOf(shape({})),
}

LastActivity.defaultProps = {
  products: [],
  topics: [],
}

export default LastActivity
